import { Box as MuiBox } from "@mui/material";
import { AppRoutes } from "app/AppRoutes";
import PropTypes from "prop-types";
import { PermissionsProvider } from "app/services/PermissionsService";
import { FilterProvider } from "app/services/filterService";
import { StudiesProvider } from "app/services/studiesService";

export const MainContainer = ({ idAttr }) => {
  return (
    <MuiBox
      id={idAttr}
      display="inline-block"
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <PermissionsProvider>
        <FilterProvider>
          <StudiesProvider>
            <AppRoutes />
          </StudiesProvider>
        </FilterProvider>
      </PermissionsProvider>
    </MuiBox>
  );
};

MainContainer.propTypes = {
  idAttr: PropTypes.string.isRequired,
};
